import React, { useEffect, useState } from 'react';
import Home from './components/Home';
import './App.css';
import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import ErrorPage from './ErrorPage';
import { Box, Container, createTheme, CssBaseline, ThemeProvider } from '@mui/material';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import SignIn from './components/SignIn';
import NewOutfits from './components/outfits/NewOutfits';
import ShowOutfit from './components/outfits/ShowOutfit';
import Authenticated from './components/shared/Authenticated';
import SharedOutfit from './components/outfits/SharedOutfit';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2c2b2b'
    },
    secondary: {
      main: '#f6f6f6'
    }
  },
});


i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: require('./locals/en.json')
    },
    es: {
      translation: require('./locals/es.json')
    }
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false
  }
});


const App = () => {
  const [installPrompt, setInstallPrompt] = useState(null)

  useEffect(() => {
    window.addEventListener("beforeinstallprompt", (e) => {
      setInstallPrompt(e)
    });
  })

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Authenticated> <Home /> </Authenticated>,
      errorElement: <ErrorPage />,
    },
    {
      path: "/newOutfits",
      element: <Authenticated><NewOutfits /></Authenticated>,
      errorElement: <ErrorPage />,
    },
    {
      path: "/showOutfit/:outfitId",
      element: <Authenticated><ShowOutfit /></Authenticated>,
      errorElement: <ErrorPage />,
    },
    {
      path: "/login",
      element: <SignIn installPrompt={installPrompt}/>,
      errorElement: <ErrorPage />,
    },
    {
      path: "/sharedOutfit/:userId/:outfitId",
      element: <SharedOutfit />,
      errorElement: <ErrorPage />,
    }
  ]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container fixed sx={{ maxWidth: { xs: 'unset', md: 'unset', lg: '1200px', padding: 0 } }}>
        <Box>
          <React.StrictMode>
            <RouterProvider router={router} />
          </React.StrictMode>
        </Box>
      </Container>
    </ThemeProvider>
  );
}

export default App;